import { authRoutes } from 'src/app/auth/interfaces'
import { Layout } from 'src/app/core/routes/components/layout'
import { parseIsPrivateRoutes } from 'src/app/core/routes/private-routes'
import { homeRoutes } from 'src/app/home/interfaces'

import { RouteObject } from './types'

/* Add any new module routes here */
export const routes: RouteObject[] = [
  // Auth routes render without the global Layout/Header chrome.
  ...parseIsPrivateRoutes(authRoutes),
  {
    element: <Layout />,
    children: [...parseIsPrivateRoutes(homeRoutes)],
  },
]
